export const isSelectDay = (day, month, year, date) => {
  return date && date.getDate() === day && date.getMonth() === month && date.getFullYear() === year;
};
